<template>

    <div class="nav-tabs-custom">
        <div class="tab-content">
            <div class="tab-pane active">
                <server-table
                    v-if="loaded"
                    :data-url="st.url"
                    :data-columns="JSON.stringify(st.columns)"
                    :preference-url="st.preferenceUrl"
                    :templates-uri="route('api.v1.templates.index')"
                ></server-table>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import ServerTable from "../../../components/Documents/ServerTable.vue";
import Lang from "../../../Lang";
import {mapGetters} from "vuex";

export default {

    components: {
        ServerTable,
    },

    computed: {
        ...mapGetters([
            'getHrUser',
        ]),
    },

    data() {
        return {
            Lang:Lang,
            loaded:false,
            st: {
                columns:[],
                url:'',
                preferenceUrl:'',
            },
        }
    },

    metaInfo: {
        title:'Documenten bekijken',
    },

    methods: {
        getUserDocuments() {
            axios.get(this.route('api.v1.documents.user.st', {user_uuid: this.getHrUser.uuid}))
                .then(resp => {
                    this.st = resp.data;
                    this.loaded = true;
                })
        },
    },

    mounted(){
        this.getUserDocuments();
    },

    name:'HrUsersDocuments',

}

</script>
